import React from 'react';
import { List, Text } from '@leverege/ui-elements';
import S from './ValueRenderer.css';
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
export default function ValueRenderer(props) {
  const {
    item,
    onEvent,
    aggregations,
    ...rest
  } = props;
  const value = item;
  const name = value.abbreviation || value.name;
  const count = aggregations?.[value.value];
  const isEmpty = count == null || count === 0;
  return /*#__PURE__*/_jsxs(List.Item, {
    item: item,
    ...rest,
    contentClassName: S.renderer,
    children: [/*#__PURE__*/_jsx(Text, {
      variant: "groupingsLabel",
      children: name
    }), /*#__PURE__*/_jsx(Text, {
      variant: isEmpty ? 'groupingsCountEmpty|groupingsCount' : 'groupingsCount',
      children: isEmpty ? '-' : count
    })]
  });
}